import { render, staticRenderFns } from "./NewsPanel.vue?vue&type=template&id=6c1b6471&scoped=true&"
import script from "./NewsPanel.vue?vue&type=script&lang=js&"
export * from "./NewsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NewsPanel.vue?vue&type=style&index=0&id=6c1b6471&scoped=true&lang=scss&"
import style1 from "./NewsPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b6471",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
